import React, { useEffect, useState } from 'react';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import { useParams } from 'react-router-dom';
import PermisosCollapsible from './PermisosCollapsible';
import axios from '../../axios';
import { useNavigate } from 'react-router-dom';
import { PaperAirplaneIcon, ShieldCheckIcon } from '@heroicons/react/24/solid';
import Alert from '../UI/Alert';

const EditarRol = () => {
    const  {rolId} = useParams();
    const navigate = useNavigate();
    const [rol,setRol] = useState({ 
        name: '',
        description: '',
        permissions_updated: []
    });
    const [permisosSelected, setPermisosSelected] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [alertConfig, setAlertConfig] = useState({ type: 'success', message: '' });

    const getRol = () => {
        axios.get(`api/get_rol/${rolId}`).then((resp) => {
            console.log(resp.data, "roles");
            setRol(resp.data);
            let permisosNames = resp.data.permissions.map(item => item.name);
            console.log("permisosNames", permisosNames);
            setPermisosSelected(permisosNames);
        }).catch(e => console.log(e));
    }

    const saveRole = () => {
        console.log("nuevo Rol", rol);
        axios.put(`api/update_rol/${rolId}`, rol).then((res) => {
            console.log("Guarda", res.data);
            setAlertConfig({
                type: 'success',
                message: 'Rol editado exitosamente'
            });
            setShowAlert(true);
            setTimeout(() => {
                navigate("/admin/roles");
            }, 3000);
        }).catch(e => {
            console.log(e);
            setAlertConfig({
                type: 'error',
                message: 'Error al editar el rol'
            });
            setShowAlert(true);
        });
    }

    useEffect(() => {
        setRol((prevRol) => ({
            ...prevRol,
            permissions_updated: permisosSelected,
        }));
    }, [permisosSelected]);

    useEffect(() => {
        getRol();
    }, []);


    return (
        <>
            <div className='container-admin-menu'>
                <Breadcrumb hasButton={false} hasFilters={false} />
            </div>
            
            <div className='container-admin-container'>
                {/* Alert de notificación */}
                {showAlert && (
                    <div className="mb-4">
                        <Alert
                            type={alertConfig.type}
                            message={alertConfig.message}
                            onClose={() => setShowAlert(false)}
                        />
                    </div>
                )}

                <div className='container-admin bg-white rounded-lg shadow-md'>
                    <h5 className='p-5 text-xl font-bold'>Editar Rol</h5>
                    
                    {/* Formulario */}
                    <div className="grid grid-cols-12 gap-4 px-5">
                        {/* Nombre del Rol */}
                        <div className="col-span-12">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="nombre" className="text-sm font-medium text-gray-600">
                                    Nombre del Rol
                                </label>
                                <input
                                    id="nombre"
                                    value={rol.name || ''}
                                    type="text"
                                    className="dento-input"
                                    onChange={(e) => setRol({...rol, name: e.target.value})}
                                />
                            </div>
                        </div>

                        {/* Descripción */}
                        <div className="col-span-12">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="descripcion" className="text-sm font-medium text-gray-600">
                                    Descripción
                                </label>
                                <textarea
                                    id="descripcion"
                                    className="dento-input min-h-25 resize-y"
                                    value={rol.description || ''}
                                    onChange={(e) => setRol({...rol, description: e.target.value})}
                                ></textarea>
                            </div>
                        </div>
                    </div>

                    {/* Badge informativo */}
                    <div className='px-5 pt-6'>
                        <div className='flex items-center gap-3 bg-blue-50 border border-blue-200 rounded-lg p-3'>
                            <div className='shrink-0'>
                                <ShieldCheckIcon className="w-6 h-6 text-blue-600" />
                            </div>
                            <div className="text-sm text-blue-800 font-medium">
                                Listado de permisos a asignar a usuarios
                            </div>
                        </div>
                    </div>

                    {/* Componente de permisos */}
                    <div className='px-5 pt-4'>
                        <PermisosCollapsible
                            permisosSelected={permisosSelected}
                            setPermisosSelected={setPermisosSelected}
                        />
                    </div>

                    {/* Botón guardar */}
                    <div className='px-5 pb-5 pt-8 flex justify-end'>
                        <button
                            type="button"
                            className="inline-flex items-center gap-2 px-6 py-2.5 bg-[#03f] text-white hover:bg-white hover:text-[#03f] hover:border-[#03f] sombra-azul-chica font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 cursor-pointer"
                            onClick={saveRole}
                        >
                            Guardar
                            <PaperAirplaneIcon className="w-5 h-5" />
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditarRol;